const DeclarationTerms = () => (
  <ol>
    <li>
      I/We declare to the best of my/our knowledge and belief that:
      <br />
      本人/我們現聲明就本人/我們所知所信:{" "}
    </li>
    <ol type="a">
      <li>
        all the answers given in this Application are true, complete and accurate in every respect;
        <br />
        所有此投保書中的內容均屬真實、準確及為事實的全部；及{" "}
      </li>
      <li>
        all materials facts/information affecting the assessment of the risk have been disclosed to the Company.
        <br />
        本人/我們已向保險公司披露所有影響保險公司風險評估的重要事實/資料。{" "}
      </li>
    </ol>
    <li>
      I/We understand that this Application will not become effective until this Application has been accepted by Allied World Assurance Company, Ltd
      (Hong Kong Branch) (the “Company”) and agree that this Application and Declaration shall form the basis of the insurance contract between myself
      and the Company. I/We understand that I/we have a duty to fully and faithfully disclose to the Company all the facts as I/we know them or ought
      to know them, otherwise, I/we may receive nothing from the policy.
      <br />
      本人/我們明白本保單會在Allied World Assurance Company, Ltd (Hong Kong Branch)世聯保險有限公司（香港分行）（下稱 “保險公司”）
      確認接受此投保書後， 方為生效。本人/我們並明白此投保書及所作之聲明將構成本人/我們與保險公司所簽署
      的保單合約之基礎。本人/我們明白我們有責任忠實地及完整地向保險公司披露所有已 知悉或應當知悉之事實，否則本人/我們可未能獲得任何保障或賠償。
    </li>
    <li>
      I/We agree that should any of the information given by me/us alter before the inception date of the insurance to which this Application relates
      or during the period of insurance, I/We will give immediate notice thereof.
      <br />
      本人/我們同意如在本保單生效前或於受保期內有任何與此投保書有關的資料之更改或 更新，本人/我們務必立即通知保險公司。
    </li>
    <li>
      I/We consent to the Company verifying the information provided in the Application with the relevant parties.
      <br />
      本人/我們同意保險公司向任何相關人士或機構查詢及核實任何本人/我們在此投保書上 提供的資料。{" "}
    </li>
    <li>
      If my/our Application was submitted via an insurance intermediary and is accepted, I/we acknowledge and agree to the Company paying the
      authorised insurance broker / the agent appointed by the Company to arrange the insurance, commission during the continuance of the policy,
      including renewals, for arranging the policy.
      <br />
      如本人/我們是透過保險中介人提交此投保書，本人/我們確知及同意保險公司會 於保單有效期內（包括續保期）向負責安排有關保單的保險中介人支付佣金。
    </li>
    <li>
      I/We have read, understand and accept the terms, conditions and exclusions outlined in the Policy Wording.
      <br />
      本人/我們已閱讀及清楚明白本保單條文的條款、細則及不保事項，並同意接受其約束 。
    </li>
  </ol>
);

export default DeclarationTerms;
